import { render, staticRenderFns } from "./product-popup-edit-Tab.vue?vue&type=template&id=10348032"
import script from "./product-popup-edit-Tab.vue?vue&type=script&lang=js"
export * from "./product-popup-edit-Tab.vue?vue&type=script&lang=js"
import style0 from "./product-popup-edit-Tab.vue?vue&type=style&index=0&id=10348032&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10348032')) {
      api.createRecord('10348032', component.options)
    } else {
      api.reload('10348032', component.options)
    }
    module.hot.accept("./product-popup-edit-Tab.vue?vue&type=template&id=10348032", function () {
      api.rerender('10348032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/product-management/product-popup-edit-Tab.vue"
export default component.exports